import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';

const themeStrings = ['dark-theme', 'light-theme'] as const;
export type ThemeString = (typeof themeStrings)[number];

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  private themeSubject = new ReplaySubject<ThemeString>(1);
  themeObservable = this.themeSubject.asObservable();

  trackingValue: boolean;
  private trackingSubject = new ReplaySubject<boolean>(1);

  constructor() {
    let theme: ThemeString = 'light-theme';
    let tracking = false;
    const storageTheme = localStorage.getItem('settings.theme');
    if (
      storageTheme &&
      (storageTheme === themeStrings[0] || storageTheme === themeStrings[1])
    ) {
      theme = storageTheme;
    } else if (!storageTheme) {
      theme = 'light-theme';
    } else {
      console.error('Theme type not found: ', storageTheme);
    }
    tracking = localStorage.getItem('settings.tracking') !== 'false';

    this.themeSubject.next(theme);
    this.trackingSubject.next(tracking);
  }

  updateTheme(themeString: ThemeString): void {
    if (themeString !== 'light-theme' && themeString !== 'dark-theme') {
      throw new Error('Error: theme type not found.');
    }
    localStorage.setItem('settings.theme', themeString);
    this.themeSubject.next(themeString);
  }

  updateTracking(isTracking: boolean): void {
    localStorage.setItem('settings.tracking', isTracking ? 'true' : 'false');
    this.trackingSubject.next(isTracking);
  }

  getTrackingOption(): boolean {
    if (typeof this.trackingValue !== 'boolean') {
      const result = localStorage.getItem('settings.tracking') !== 'false';
      if (result === null) {
        this.trackingValue = true;
      } else {
        this.trackingValue = result;
      }
    }
    return this.trackingValue;
  }

  getMobileOperatingSystem(): string {
    const userAgent = navigator.userAgent || navigator.vendor;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return 'Windows Phone';
    }

    if (/android/i.test(userAgent)) {
      return 'Android';
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent)) {
      return 'iOS';
    }

    return '';
  }
}
